import globals from '../../../components/common/globals';
import vxMysteryHeader from '../vx-mystery-header/vx-mystery-header.vue';
import vxMysteryFooter from '../vx-mystery-footer/vx-mystery-footer.vue';

export default {
  name: 'vx-mystery-opt-in-thank-you',
  components: { vxMysteryHeader, vxMysteryFooter },
  data() {
    return {
      globals,
      title: 'Opt in Thank you page',
    };
  },
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-opt-in-thank-you/vx-mystery-opt-in-thank-you.js